import { FeatureFlagIdActionTicketType } from 'c1gen/features'
import { EndUserTaskListItem } from 'components/core/end-user-task-list/EndUserTaskList'
import { useFeatureChecker } from 'components/no-ui/capability'
import { EndUserDashboardSection } from 'components/pages/end-user-dashboard/EndUserDashboardSection'
import { ActionTaskType, GrantTaskType, RevokeTaskType } from 'components/pages/task/type'
import { TaskValue } from 'lib/actions/task'
import { UserContext } from 'lib/context/app'
import { routes } from 'lib/routes'
import { TaskSearchCountRequest, TaskSearchRequest } from 'pbts/c1/api/task/v1/search'
import { TaskState } from 'pbts/c1/api/task/v1/task'
import { FC, useContext, useMemo } from 'react'
import { useIntl } from 'react-intl'
import { getTaskSearchCountApi, tasksSearchApi } from 'redux_toolkit/tasks'

export const EndUserDashboardTasks: FC = () => {
    const intl = useIntl()
    const { user } = useContext(UserContext)
    const userId = user?.id
    const isActionTicketTypeEnabled = useFeatureChecker(FeatureFlagIdActionTicketType)

    const filter = useMemo((): TaskSearchRequest => {
        const taskTypes = isActionTicketTypeEnabled
            ? [GrantTaskType, RevokeTaskType, ActionTaskType]
            : [GrantTaskType, RevokeTaskType]

        return TaskSearchRequest.create({
            assigneesInIds: [userId],
            taskTypes,
            taskStates: [TaskState.OPEN],
        })
    }, [userId, isActionTicketTypeEnabled])

    return <EndUserDashboardSection<TaskValue, TaskSearchRequest, TaskSearchCountRequest>
        title={intl.formatMessage({
            id: 'end_user_dashboard_tasks_title',
            defaultMessage: 'Tasks assigned to you',
        })}
        seeAllHref={routes.requests.assignedToMe}
        seeAllLabel={(count): string => (count === 1
            ? intl.formatMessage({
                id: 'end_user_dashboard_tasks_see_all_one',
                defaultMessage: 'See task',
            })
            : intl.formatMessage({
                id: 'end_user_dashboard_tasks_see_all',
                defaultMessage: 'See all {count} tasks',
            }, { count }))}
        ListItemComponent={EndUserTaskListItem}
        getDataHook={tasksSearchApi.useSearch}
        getDataRequest={{
            ...filter,
            expandMask: { paths: ['*'] },
        }}
        getCountHook={getTaskSearchCountApi.useSearchCount}
        getCountRequest={TaskSearchCountRequest.create({ filter })}
        invalidateHook={tasksSearchApi.useInvalidateSearch}
    />
}
